export enum QueryKey {
  registerUserFeedback = 'registerUserFeedback',
}
